import React, { FC } from 'react';

import { Stack, Typography, useDesktop } from 'Modules/ui3';
import { ModalComponentProps } from 'Modules/core/messaging';

import modalStyles from '../ui/index.module.scss';
import { PARTNER_EMAIL } from '../../constants';


const ContactsModalComponent: FC = () => {
    const isDesktop = useDesktop();
    return (
        <Stack
            data-testid='modal-partnerInfo'
            pt={isDesktop ? 13 : 14}
            pb={isDesktop ? 12 : 8}
            px={isDesktop ? 8 : 5}
            maxWidth='448px'
        >
            <Typography
                fontSize={isDesktop ? '25px' : '20px'}
                fontWeight='500'
                lineHeight={isDesktop ? '1.3' : '1.4'}
                color='grayscale.shade95'
            >
                Ваши клиенты получат доступ к&nbsp;ЦФА не выходя из своих приложений!
            </Typography>
            <Typography
                fontSize={isDesktop ? '20px' : '16px'}
                fontWeight='400'
                lineHeight={isDesktop ? '1.5' : '1.4'}
                mt={isDesktop ? 6 : 4}
                mb={isDesktop ? 2 : 1}
                color='grayscale.shade90'
            >
                Хотите стать партнером платформы — напишите нам на
            </Typography>
            <Typography
                href={`mailto:${PARTNER_EMAIL}`}
                component='a'
                fontSize={isDesktop ? '25px' : '20px'}
                fontWeight='400'
                lineHeight='1.5'
            >
                {PARTNER_EMAIL}
            </Typography>
        </Stack>
    );
};

export const ContactsModal: ModalComponentProps = {
    component: ContactsModalComponent,
    containerClass: modalStyles.container,
    modalClass: modalStyles.modal,
    customCloseButton: null,
};
